/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import Chip from "@material-ui/core/Chip";
import Switch from "@material-ui/core/Switch";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import Paper from "@material-ui/core/Paper";

// Material-UI Icons
import Add from "@material-ui/icons/Add";
import Edit from "@material-ui/icons/Edit";
import Delete from "@material-ui/icons/Delete";
import Settings from "@material-ui/icons/Settings";
import ArrowBack from "@material-ui/icons/ArrowBack";
import AccessTime from "@material-ui/icons/AccessTime";
import EventAvailable from "@material-ui/icons/EventAvailable";
import CheckCircle from "@material-ui/icons/CheckCircle";
import Block from "@material-ui/icons/Block";

// Core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import Button from "components/CustomButtons/Button.js";

// Reactstrap
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
  Row,
  Col,
} from "reactstrap";

const useStyles = makeStyles((theme) => ({
  cardCategoryWhite: {
    color: "rgba(255,255,255,.8)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "500",
    fontFamily: '"Sarabun", sans-serif',
    marginBottom: "3px",
    textDecoration: "none",
  },
  tableResponsive: {
    width: "100%",
    overflowX: "auto",
  },
  headerAction: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "10px",
  },
  badgeForgot: {
    backgroundColor: "#fff3e0",
    color: "#e65100",
    border: "1px solid #ffb74d",
    fontWeight: "bold",
  },
  badgeQuota: {
    backgroundColor: "#e8f5e9",
    color: "#2e7d32",
    border: "1px solid #81c784",
    fontWeight: "bold",
  },
}));

const MODE_OPTIONS = [
  { value: 1, label: "ลงเวลาเข้างาน (ระบุเวลาเข้าจริง)" },
  { value: 2, label: "ลงเวลาออกงาน (ระบุเวลาออกจริง)" },
  { value: 3, label: "ลืมทั้งเข้าและออกงาน (ระบุเวลาจริงทั้งสอง)" },
  { value: 10, label: "ขอตามโควต้า (ระบุช่วงเวลา และตัดโควต้า)" },
];

const LIMIT_TYPE_OPTIONS = [
  { value: 0, label: "ไม่จำกัดโควต้า" },
  { value: 1, label: "ต่อสัปดาห์ (จันทร์ - อาทิตย์)" },
  { value: 2, label: "ต่อเดือน" },
  { value: 3, label: "ต่อครึ่งปีงบประมาณ (ต.ค. - มี.ค. / เม.ย. - ก.ย.)" },
  { value: 4, label: "ต่อปีงบประมาณ (1 ต.ค. - 30 ก.ย.)" },
];

export default function AttendanceSetting() {
  const classes = useStyles();
  const history = useHistory();

  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);

  // Form Modal States
  const [modalOpen, setModalOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [formData, setFormData] = useState({
    categoryID: 0,
    categoryName: "",
    description: "",
    categoryMode: 10,
    maxHoursPerRequest: 2.0,
    quotaLimitType: 2, // ต่อเดือน
    quotaMaxCount: 2,
    allowMorning: true,
    allowAfternoon: true,
    lv1Text: "พยาน (เจ้าหน้าที่ร่วมรับรอง)",
    isDisableLv1: false,
    sortOrder: 10,
    isActive: true,
  });

  // Delete Modal
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [targetCategory, setTargetCategory] = useState(null);

  // Notification Modal
  const [alertModal, setAlertModal] = useState({
    open: false,
    title: "",
    message: "",
    isError: false,
  });

  const loadCategories = () => {
    setLoading(true);
    axios
      .get("/api/v1/timeattendance/categories/all")
      .then((res) => {
        if (res.data?.result === 200) {
          setCategories(res.data.data || []);
        } else {
          setAlertModal({
            open: true,
            title: "แจ้งเตือน",
            message: res.data?.msg || "ไม่สามารถดึงข้อมูลได้",
            isError: true,
          });
        }
      })
      .catch((err) => {
        setAlertModal({
          open: true,
          title: "เกิดข้อผิดพลาด",
          message: "ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้",
          isError: true,
        });
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    loadCategories();
  }, []);

  const handleOpenAdd = () => {
    setIsEditMode(false);
    setFormData({
      categoryID: 0,
      categoryName: "",
      description: "",
      categoryMode: 10,
      maxHoursPerRequest: 2.0,
      quotaLimitType: 2,
      quotaMaxCount: 2,
      allowMorning: true,
      allowAfternoon: true,
      lv1Text: "พยาน (เจ้าหน้าที่ร่วมรับรอง)",
      isDisableLv1: false,
      sortOrder: (categories.length + 1) * 10,
      isActive: true,
    });
    setModalOpen(true);
  };

  const handleOpenEdit = (item) => {
    setIsEditMode(true);
    setFormData({
      categoryID: item.categoryID,
      categoryName: item.categoryName || "",
      description: item.description || "",
      categoryMode: item.categoryMode || 10,
      maxHoursPerRequest: item.maxHoursPerRequest != null ? item.maxHoursPerRequest : 2.0,
      quotaLimitType: item.quotaLimitType != null ? item.quotaLimitType : 2,
      quotaMaxCount: item.quotaMaxCount != null ? item.quotaMaxCount : 2,
      allowMorning: item.allowMorning !== false,
      allowAfternoon: item.allowAfternoon !== false,
      lv1Text: item.lv1Text !== undefined && item.lv1Text !== null ? item.lv1Text : (item.isDisableLv1 ? "" : "พยาน (เจ้าหน้าที่ร่วมรับรอง)"),
      isDisableLv1: Boolean(item.isDisableLv1),
      sortOrder: item.sortOrder || 10,
      isActive: item.isActive,
    });
    setModalOpen(true);
  };

  const handleSave = () => {
    if (!formData.categoryName.trim()) {
      setAlertModal({
        open: true,
        title: "ข้อผิดพลาด",
        message: "กรุณาระบุชื่อหมวดหมู่",
        isError: true,
      });
      return;
    }

    if (formData.categoryMode === 10 && !formData.allowMorning && !formData.allowAfternoon) {
      setAlertModal({
        open: true,
        title: "ข้อผิดพลาด",
        message: "กรุณาเลือกช่วงเวลาที่อนุญาตอย่างน้อย 1 ช่วง (ช่วงเช้า หรือ ช่วงบ่าย)",
        isError: true,
      });
      return;
    }

    const payload = {
      ...formData,
      maxHoursPerRequest: formData.categoryMode === 10 ? Number(formData.maxHoursPerRequest) : null,
      quotaMaxCount: formData.categoryMode === 10 ? Number(formData.quotaMaxCount) : null,
      quotaLimitType: formData.categoryMode === 10 ? Number(formData.quotaLimitType) : 0,
      allowMorning: formData.categoryMode === 10 ? Boolean(formData.allowMorning) : true,
      allowAfternoon: formData.categoryMode === 10 ? Boolean(formData.allowAfternoon) : true,
      lv1Text: formData.isDisableLv1 ? "" : (formData.lv1Text || ""),
      isDisableLv1: Boolean(formData.isDisableLv1),
      sortOrder: Number(formData.sortOrder) || 10,
    };

    if (isEditMode) {
      axios
        .put(`/api/v1/timeattendance/categories/${formData.categoryID}`, payload)
        .then((res) => {
          if (res.data?.result === 200) {
            setModalOpen(false);
            loadCategories();
            setAlertModal({
              open: true,
              title: "สำเร็จ",
              message: "บันทึกข้อมูลเรียบร้อยแล้ว",
              isError: false,
            });
          } else {
            setAlertModal({
              open: true,
              title: "แจ้งเตือน",
              message: res.data?.msg || "บันทึกไม่สำเร็จ",
              isError: true,
            });
          }
        })
        .catch(() => {
          setAlertModal({
            open: true,
            title: "เกิดข้อผิดพลาด",
            message: "ไม่สามารถบันทึกข้อมูลได้",
            isError: true,
          });
        });
    } else {
      axios
        .post("/api/v1/timeattendance/categories", payload)
        .then((res) => {
          if (res.data?.result === 200) {
            setModalOpen(false);
            loadCategories();
            setAlertModal({
              open: true,
              title: "สำเร็จ",
              message: "เพิ่มหมวดหมู่ใหม่เรียบร้อยแล้ว",
              isError: false,
            });
          } else {
            setAlertModal({
              open: true,
              title: "แจ้งเตือน",
              message: res.data?.msg || "บันทึกไม่สำเร็จ",
              isError: true,
            });
          }
        })
        .catch(() => {
          setAlertModal({
            open: true,
            title: "เกิดข้อผิดพลาด",
            message: "ไม่สามารถบันทึกข้อมูลได้",
            isError: true,
          });
        });
    }
  };

  const handleToggleActive = (item) => {
    axios
      .put(`/api/v1/timeattendance/categories/${item.categoryID}/toggle`)
      .then((res) => {
        if (res.data?.result === 200) {
          loadCategories();
        } else {
          setAlertModal({
            open: true,
            title: "แจ้งเตือน",
            message: res.data?.msg || "ไม่สามารถเปลี่ยนสถานะได้",
            isError: true,
          });
        }
      })
      .catch(() => {
        setAlertModal({
          open: true,
          title: "เกิดข้อผิดพลาด",
          message: "ไม่สามารถเชื่อมต่อเซิร์ฟเวอร์ได้",
          isError: true,
        });
      });
  };

  const handleOpenDelete = (item) => {
    setTargetCategory(item);
    setDeleteModalOpen(true);
  };

  const handleConfirmDelete = () => {
    if (!targetCategory) return;
    axios
      .delete(`/api/v1/timeattendance/categories/${targetCategory.categoryID}`)
      .then((res) => {
        setDeleteModalOpen(false);
        loadCategories();
        setAlertModal({
          open: true,
          title: "สำเร็จ",
          message: res.data?.msg || "ดำเนินการเรียบร้อยแล้ว",
          isError: false,
        });
      })
      .catch(() => {
        setDeleteModalOpen(false);
        setAlertModal({
          open: true,
          title: "เกิดข้อผิดพลาด",
          message: "ไม่สามารถลบหมวดหมู่ได้",
          isError: true,
        });
      });
  };

  const getModeBadge = (mode) => {
    switch (mode) {
      case 1:
        return <Chip size="small" label="ลงเวลาเข้างาน" className={classes.badgeForgot} />;
      case 2:
        return <Chip size="small" label="ลงเวลาออกงาน" className={classes.badgeForgot} />;
      case 3:
        return <Chip size="small" label="ลืมทั้งเข้าและออก" className={classes.badgeForgot} />;
      case 10:
        return <Chip size="small" label="ขอตามโควต้า" className={classes.badgeQuota} />;
      default:
        return <Chip size="small" label={`โหมด ${mode}`} />;
    }
  };

  const getLimitTypeText = (type, count) => {
    if (!count || type === 0) return "ไม่จำกัด";
    switch (type) {
      case 1:
        return `${count} ครั้ง / สัปดาห์`;
      case 2:
        return `${count} ครั้ง / เดือน`;
      case 3:
        return `${count} ครั้ง / ครึ่งปี`;
      case 4:
        return `${count} ครั้ง / ปีงบประมาณ`;
      default:
        return `${count} ครั้ง`;
    }
  };

  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="primary">
              <div className={classes.headerAction}>
                <div>
                  <h4 className={classes.cardTitleWhite}>
                    <Settings style={{ verticalAlign: "middle", marginRight: "8px" }} />
                    ตั้งค่าประเภทการลงเวลาปฏิบัติราชการ
                  </h4>
                  <p className={classes.cardCategoryWhite}>
                    จัดการหมวดหมู่การลืมลงเวลา และหมวดหมู่การขออนุญาตตามโควต้า (กำหนดสิทธิ์ชั่วโมงและรอบความถี่)
                  </p>
                </div>
                <div style={{ display: "flex", gap: "10px" }}>
                  <Button
                    color="transparent"
                    style={{ color: "white", border: "1px solid white" }}
                    onClick={() => history.push("/hr/attendance/hr")}
                  >
                    <ArrowBack style={{ marginRight: "4px" }} /> กลับหน้ารายการ
                  </Button>
                  <Button color="info" onClick={handleOpenAdd}>
                    <Add style={{ marginRight: "4px" }} /> เพิ่มหมวดหมู่ใหม่
                  </Button>
                </div>
              </div>
            </CardHeader>

            <CardBody>
              <div className={classes.tableResponsive}>
                <Table>
                  <TableHead>
                    <TableRow style={{ backgroundColor: "#f5f5f5" }}>
                      <TableCell style={{ fontWeight: "bold", width: "80px", textAlign: "center" }}>
                        ลำดับ
                      </TableCell>
                      <TableCell style={{ fontWeight: "bold" }}>ชื่อหมวดหมู่ / รายละเอียด</TableCell>
                      <TableCell style={{ fontWeight: "bold", textAlign: "center", width: "160px" }}>
                        รูปแบบ
                      </TableCell>
                      <TableCell style={{ fontWeight: "bold", textAlign: "center", width: "180px" }}>
                        ผู้อนุมัติขั้นที่ 1 (พยาน)
                      </TableCell>
                      <TableCell style={{ fontWeight: "bold", textAlign: "center", width: "140px" }}>
                        สิทธิ์ชั่วโมง/ครั้ง
                      </TableCell>
                      <TableCell style={{ fontWeight: "bold", textAlign: "center", width: "180px" }}>
                        โควต้าความถี่
                      </TableCell>
                      <TableCell style={{ fontWeight: "bold", textAlign: "center", width: "120px" }}>
                        เปิดใช้งาน
                      </TableCell>
                      <TableCell style={{ fontWeight: "bold", textAlign: "center", width: "120px" }}>
                        จัดการ
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {categories.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={8} style={{ textAlign: "center", padding: "30px" }}>
                          <Typography variant="body1" color="textSecondary">
                            {loading ? "กำลังโหลดข้อมูล..." : "ยังไม่มีข้อมูลหมวดหมู่"}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    ) : (
                      categories.map((item, idx) => (
                        <TableRow key={item.categoryID} hover style={{ opacity: item.isActive ? 1 : 0.6 }}>
                          <TableCell style={{ textAlign: "center", fontWeight: "bold" }}>
                            {item.sortOrder}
                          </TableCell>
                          <TableCell>
                            <div style={{ fontWeight: "bold", fontSize: "15px", color: "#333" }}>
                              {item.categoryName}
                            </div>
                            {item.description && (
                              <div style={{ fontSize: "13px", color: "#666", marginTop: "2px" }}>
                                {item.description}
                              </div>
                            )}
                          </TableCell>
                          <TableCell style={{ textAlign: "center" }}>
                            {getModeBadge(item.categoryMode)}
                            {item.categoryMode === 10 && (
                              <div style={{ marginTop: "4px" }}>
                                {item.allowMorning !== false && item.allowAfternoon !== false ? (
                                  <span style={{ fontSize: "11px", backgroundColor: "#e3f2fd", color: "#1565c0", padding: "2px 6px", borderRadius: "4px", display: "inline-block" }}>
                                    เช้า & บ่าย
                                  </span>
                                ) : item.allowMorning !== false ? (
                                  <span style={{ fontSize: "11px", backgroundColor: "#fff8e1", color: "#f57f17", padding: "2px 6px", borderRadius: "4px", display: "inline-block" }}>
                                    เช้าเท่านั้น (08:00+)
                                  </span>
                                ) : (
                                  <span style={{ fontSize: "11px", backgroundColor: "#ede7f6", color: "#512da8", padding: "2px 6px", borderRadius: "4px", display: "inline-block" }}>
                                    บ่ายเท่านั้น (13:00+)
                                  </span>
                                )}
                              </div>
                            )}
                          </TableCell>
                          <TableCell style={{ textAlign: "center" }}>
                            {item.isDisableLv1 ? (
                              <Chip
                                size="small"
                                label="ปิดพยาน (เฉพาะหัวหน้า)"
                                style={{ backgroundColor: "#ffebee", color: "#c62828", fontSize: "11px", fontWeight: "bold", border: "1px solid #ffcdd2" }}
                              />
                            ) : (
                              <Chip
                                size="small"
                                label={item.lv1Text || "พยาน (เจ้าหน้าที่ร่วมรับรอง)"}
                                style={{ backgroundColor: "#e8eaf6", color: "#283593", fontSize: "11px", border: "1px solid #c5cae9" }}
                              />
                            )}
                          </TableCell>
                          <TableCell style={{ textAlign: "center" }}>
                            {item.categoryMode === 10 && item.maxHoursPerRequest ? (
                              <span style={{ fontWeight: "bold", color: "#1976d2" }}>
                                <AccessTime style={{ fontSize: "16px", verticalAlign: "middle", marginRight: "3px" }} />
                                {item.maxHoursPerRequest} ชม.
                              </span>
                            ) : (
                              <span style={{ color: "#aaa" }}>-</span>
                            )}
                          </TableCell>
                          <TableCell style={{ textAlign: "center" }}>
                            {item.categoryMode === 10 ? (
                              <span style={{ fontWeight: "bold", color: "#388e3c" }}>
                                <EventAvailable style={{ fontSize: "16px", verticalAlign: "middle", marginRight: "3px" }} />
                                {getLimitTypeText(item.quotaLimitType, item.quotaMaxCount)}
                              </span>
                            ) : (
                              <span style={{ color: "#aaa" }}>-</span>
                            )}
                          </TableCell>
                          <TableCell style={{ textAlign: "center" }}>
                            <Tooltip title={item.isActive ? "คลิกเพื่อปิดใช้งาน" : "คลิกเพื่อเปิดใช้งาน"}>
                              <Switch
                                checked={Boolean(item.isActive)}
                                onChange={() => handleToggleActive(item)}
                                color="primary"
                              />
                            </Tooltip>
                          </TableCell>
                          <TableCell style={{ textAlign: "center" }}>
                            <Tooltip title="แก้ไข">
                              <IconButton
                                size="small"
                                style={{ color: "#ff9800", marginRight: "5px" }}
                                onClick={() => handleOpenEdit(item)}
                              >
                                <Edit fontSize="small" />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="ลบ / ยกเลิกใช้งาน">
                              <IconButton
                                size="small"
                                style={{ color: "#f44336" }}
                                onClick={() => handleOpenDelete(item)}
                              >
                                <Delete fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </div>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>

      {/* Modal Add / Edit Category */}
      <Modal isOpen={modalOpen} toggle={() => setModalOpen(!modalOpen)} size="lg">
        <ModalHeader toggle={() => setModalOpen(!modalOpen)}>
          <span style={{ fontWeight: "bold", fontSize: "18px" }}>
            {isEditMode ? "แก้ไขหมวดหมู่การลงเวลา" : "เพิ่มหมวดหมู่การลงเวลาใหม่"}
          </span>
        </ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label style={{ fontWeight: "bold" }}>
              ชื่อหมวดหมู่ <span style={{ color: "red" }}>*</span>
            </Label>
            <Input
              type="text"
              placeholder="เช่น ขอออกไปทำกิจธุระส่วนตัว, การตรวจทันตกรรม ณ สสจ.ตรัง"
              value={formData.categoryName}
              onChange={(e) => setFormData({ ...formData, categoryName: e.target.value })}
            />
          </FormGroup>

          <FormGroup>
            <Label style={{ fontWeight: "bold" }}>รายละเอียด / คำชี้แจงเพิ่มเติม</Label>
            <Input
              type="textarea"
              rows={2}
              placeholder="คำอธิบาย หรือเงื่อนไขที่ให้เจ้าหน้าที่รับทราบ"
              value={formData.description}
              onChange={(e) => setFormData({ ...formData, description: e.target.value })}
            />
          </FormGroup>

          <Row>
            <Col md={6}>
              <FormGroup>
                <Label style={{ fontWeight: "bold" }}>
                  รูปแบบการลงเวลา <span style={{ color: "red" }}>*</span>
                </Label>
                <Input
                  type="select"
                  value={formData.categoryMode}
                  onChange={(e) => setFormData({ ...formData, categoryMode: Number(e.target.value) })}
                >
                  {MODE_OPTIONS.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </Input>
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label style={{ fontWeight: "bold" }}>ลำดับการแสดงผล (Sort Order)</Label>
                <Input
                  type="number"
                  value={formData.sortOrder}
                  onChange={(e) => setFormData({ ...formData, sortOrder: e.target.value })}
                />
              </FormGroup>
            </Col>
          </Row>

          {/* การตั้งค่าผู้อนุมัติขั้นที่ 1 (พยาน / เจ้าหน้าที่ร่วมรับรอง) */}
          <div
            style={{
              background: formData.isDisableLv1 ? "#fff3e0" : "#e8eaf6",
              border: `1px solid ${formData.isDisableLv1 ? "#ffe0b2" : "#c5cae9"}`,
              borderRadius: "6px",
              padding: "16px",
              marginTop: "12px",
              marginBottom: "12px",
            }}
          >
            <Typography
              variant="subtitle2"
              style={{
                fontWeight: "bold",
                color: formData.isDisableLv1 ? "#e65100" : "#283593",
                marginBottom: "10px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <CheckCircle style={{ fontSize: "18px", marginRight: "6px" }} />
              ตั้งค่าผู้อนุมัติขั้นที่ 1 (พยาน / เจ้าหน้าที่ร่วมรับรอง)
            </Typography>

            <FormGroup check style={{ marginBottom: formData.isDisableLv1 ? 0 : "12px" }}>
              <Label check style={{ fontWeight: "bold", cursor: "pointer", color: formData.isDisableLv1 ? "#d84315" : "#333" }}>
                <Input
                  type="checkbox"
                  checked={Boolean(formData.isDisableLv1)}
                  onChange={(e) => {
                    const checked = e.target.checked;
                    setFormData({
                      ...formData,
                      isDisableLv1: checked,
                      lv1Text: checked ? "" : (formData.lv1Text || "พยาน (เจ้าหน้าที่ร่วมรับรอง)"),
                    });
                  }}
                />{" "}
                ปิดการใช้พยานรับรอง (isDisableLv1) — ในหน้าสร้างคำขอจะมีเฉพาะหัวหน้าอนุมัติ
              </Label>
            </FormGroup>

            {!formData.isDisableLv1 && (
              <FormGroup style={{ marginBottom: 0 }}>
                <Label style={{ fontWeight: "bold", fontSize: "13px" }}>
                  ชื่อเรียกตำแหน่งพยาน / เจ้าหน้าที่ร่วมรับรอง (Lv1Text)
                </Label>
                <Input
                  type="text"
                  placeholder="เช่น พยาน (เจ้าหน้าที่ร่วมรับรอง)"
                  value={formData.lv1Text}
                  onChange={(e) => setFormData({ ...formData, lv1Text: e.target.value })}
                />
                <span style={{ fontSize: "12px", color: "#666", marginTop: "4px", display: "block" }}>
                  * ระบุชื่อที่ต้องการให้แสดง เช่น "พยาน (เจ้าหน้าที่ร่วมรับรอง)"
                </span>
              </FormGroup>
            )}
          </div>

          {formData.categoryMode === 10 && (
            <div
              style={{
                background: "#f1f8e9",
                border: "1px solid #c8e6c9",
                borderRadius: "6px",
                padding: "16px",
                marginTop: "10px",
                marginBottom: "15px",
              }}
            >
              <Typography
                variant="subtitle2"
                style={{ fontWeight: "bold", color: "#2e7d32", marginBottom: "12px" }}
              >
                <EventAvailable style={{ verticalAlign: "middle", marginRight: "6px" }} />
                กำหนดสิทธิ์และเงื่อนไขโควต้า (สำหรับหมวดขอตามโควต้า)
              </Typography>

              <Row>
                <Col md={4}>
                  <FormGroup>
                    <Label style={{ fontWeight: "bold" }}>สิทธิ์ชั่วโมงสูงสุดต่อครั้ง</Label>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <Input
                        type="number"
                        step="0.5"
                        min="0.5"
                        max="24"
                        value={formData.maxHoursPerRequest}
                        onChange={(e) =>
                          setFormData({ ...formData, maxHoursPerRequest: e.target.value })
                        }
                      />
                      <span style={{ marginLeft: "8px", fontWeight: "bold", whiteSpace: "nowrap" }}>
                        ชั่วโมง
                      </span>
                    </div>
                  </FormGroup>
                </Col>

                <Col md={4}>
                  <FormGroup>
                    <Label style={{ fontWeight: "bold" }}>รอบการนับโควต้า</Label>
                    <Input
                      type="select"
                      value={formData.quotaLimitType}
                      onChange={(e) =>
                        setFormData({ ...formData, quotaLimitType: Number(e.target.value) })
                      }
                    >
                      {LIMIT_TYPE_OPTIONS.map((opt) => (
                        <option key={opt.value} value={opt.value}>
                          {opt.label}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                </Col>

                <Col md={4}>
                  <FormGroup>
                    <Label style={{ fontWeight: "bold" }}>จำนวนครั้งที่ขอได้ต่อรอบ</Label>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <Input
                        type="number"
                        min="1"
                        max="100"
                        disabled={formData.quotaLimitType === 0}
                        value={formData.quotaMaxCount}
                        onChange={(e) =>
                          setFormData({ ...formData, quotaMaxCount: e.target.value })
                        }
                      />
                      <span style={{ marginLeft: "8px", fontWeight: "bold", whiteSpace: "nowrap" }}>
                        ครั้ง
                      </span>
                    </div>
                  </FormGroup>
                </Col>
              </Row>

              <FormGroup style={{ marginTop: "12px", marginBottom: "0px" }}>
                <Label style={{ fontWeight: "bold", display: "block", color: "#2e7d32" }}>
                  ช่วงเวลาที่อนุญาตให้ขอ <span style={{ color: "red" }}>*</span>
                </Label>
                <div style={{ display: "flex", gap: "24px", alignItems: "center", flexWrap: "wrap", marginTop: "4px" }}>
                  <label style={{ display: "flex", alignItems: "center", cursor: "pointer", margin: 0 }}>
                    <input
                      type="checkbox"
                      style={{ width: "18px", height: "18px", marginRight: "8px", accentColor: "#2e7d32" }}
                      checked={Boolean(formData.allowMorning)}
                      onChange={(e) =>
                        setFormData({ ...formData, allowMorning: e.target.checked })
                      }
                    />
                    <span style={{ fontSize: "14px", fontWeight: "500", color: "#333" }}>
                      🌅 ช่วงเช้า (เริ่ม 08:00 น. เป็นต้นไป)
                    </span>
                  </label>
                  <label style={{ display: "flex", alignItems: "center", cursor: "pointer", margin: 0 }}>
                    <input
                      type="checkbox"
                      style={{ width: "18px", height: "18px", marginRight: "8px", accentColor: "#2e7d32" }}
                      checked={Boolean(formData.allowAfternoon)}
                      onChange={(e) =>
                        setFormData({ ...formData, allowAfternoon: e.target.checked })
                      }
                    />
                    <span style={{ fontSize: "14px", fontWeight: "500", color: "#333" }}>
                      🌇 ช่วงบ่าย (เริ่ม 13:00 น. เป็นต้นไป)
                    </span>
                  </label>
                </div>
                {!formData.allowMorning && !formData.allowAfternoon && (
                  <span style={{ color: "#d32f2f", fontSize: "12px", marginTop: "6px", display: "block", fontWeight: "bold" }}>
                    * ต้องเลือกอย่างน้อย 1 ช่วงเวลา (ช่วงเช้า หรือ ช่วงบ่าย)
                  </span>
                )}
              </FormGroup>
            </div>
          )}

          <FormGroup check style={{ marginTop: "10px" }}>
            <Label check style={{ fontWeight: "bold", cursor: "pointer" }}>
              <Input
                type="checkbox"
                checked={Boolean(formData.isActive)}
                onChange={(e) => setFormData({ ...formData, isActive: e.target.checked })}
              />{" "}
              เปิดให้เจ้าหน้าที่เลือกหมวดหมู่นี้ในระบบ
            </Label>
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setModalOpen(false)}>
            ยกเลิก
          </Button>
          <Button color="primary" onClick={handleSave}>
            บันทึก
          </Button>
        </ModalFooter>
      </Modal>

      {/* Modal Confirm Delete */}
      <Modal isOpen={deleteModalOpen} toggle={() => setDeleteModalOpen(!deleteModalOpen)}>
        <ModalHeader toggle={() => setDeleteModalOpen(!deleteModalOpen)}>
          ยืนยันการลบ / ยกเลิกหมวดหมู่
        </ModalHeader>
        <ModalBody>
          คุณต้องการลบหมวดหมู่ <strong>{targetCategory?.categoryName}</strong> ใช่หรือไม่?
          <div style={{ color: "#e65100", fontSize: "13px", marginTop: "8px" }}>
            * หมายเหตุ: หากหมวดหมู่นี้มีการนำไปใช้ขอลงเวลาแล้ว ระบบจะปิดการใช้งาน (Inactive) แทนการลบข้อมูลจริงเพื่อความถูกต้องของประวัติ
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setDeleteModalOpen(false)}>
            ยกเลิก
          </Button>
          <Button color="danger" onClick={handleConfirmDelete}>
            ยืนยัน
          </Button>
        </ModalFooter>
      </Modal>

      {/* Alert / Notification Modal */}
      <Modal
        isOpen={alertModal.open}
        toggle={() => setAlertModal({ ...alertModal, open: false })}
      >
        <ModalHeader toggle={() => setAlertModal({ ...alertModal, open: false })}>
          {alertModal.title}
        </ModalHeader>
        <ModalBody>
          <p style={{ margin: 0, fontSize: "15px", color: alertModal.isError ? "#d32f2f" : "#2e7d32" }}>
            {alertModal.message}
          </p>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => setAlertModal({ ...alertModal, open: false })}>
            ตกลง
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}
